var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4235_155847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.332 12H10.6654C10.3117 12 9.9726 12.1405 9.72256 12.3905C9.47251 12.6406 9.33203 12.9797 9.33203 13.3333V26.6667C9.33203 27.0203 9.47251 27.3594 9.72256 27.6095C9.9726 27.8595 10.3117 28 10.6654 28H29.332C29.6857 28 30.0248 27.8595 30.2748 27.6095C30.5249 27.3594 30.6654 27.0203 30.6654 26.6667V13.3333C30.6654 12.9797 30.5249 12.6406 30.2748 12.3905C30.0248 12.1405 29.6857 12 29.332 12ZM28.3054 26.6667H11.772L16.4387 21.84L15.4787 20.9133L10.6654 25.8933V14.3467L18.952 22.5933C19.2018 22.8417 19.5398 22.9811 19.892 22.9811C20.2443 22.9811 20.5822 22.8417 20.832 22.5933L29.332 14.14V25.8067L24.4254 20.9L23.4854 21.84L28.3054 26.6667ZM11.5387 13.3333H28.252L19.892 21.6467L11.5387 13.3333Z",
    fill: "#343440"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4235_155847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message-icon.f260f5d5f3f1651553e8a89b0dc42016.svg";
export { ForwardRef as ReactComponent };